export const PeopleIcon = ({
  className,
  width = "44",
  height = "44",
  style,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <rect width="44" height="44" rx="22" fill="#FDFDFD" />
      <path
        d="M26.3749 22C25.2506 22 24.1634 21.498 23.3124 20.5869C22.485 19.6982 21.9797 18.5131 21.8906 17.2509C21.7954 15.9045 22.2061 14.6664 23.0467 13.7641C23.8872 12.8617 25.0624 12.375 26.3749 12.375C27.6781 12.375 28.8567 12.8705 29.6945 13.7706C30.5405 14.6795 30.9523 15.9155 30.8571 17.2504C30.7658 18.5142 30.261 19.6987 29.4352 20.5863C28.5865 21.498 27.4999 22 26.3749 22ZM33.5844 31.625H19.166C18.9342 31.6262 18.7052 31.5743 18.4966 31.4731C18.288 31.372 18.1055 31.2243 17.9629 31.0415C17.8117 30.8433 17.7073 30.6135 17.6575 30.3693C17.6076 30.125 17.6137 29.8727 17.6753 29.6311C18.1357 27.7821 19.2765 26.2487 20.974 25.197C22.4806 24.2641 24.3985 23.75 26.3749 23.75C28.3902 23.75 30.2577 24.2422 31.7731 25.1746C33.4745 26.2208 34.6169 27.763 35.0752 29.6344C35.136 29.8761 35.1414 30.1285 35.091 30.3726C35.0406 30.6167 34.9357 30.8463 34.7842 31.0442C34.6418 31.2262 34.4597 31.3731 34.2517 31.4738C34.0437 31.5745 33.8154 31.6262 33.5844 31.625ZM16.039 22.2187C14.1145 22.2187 12.4225 20.4294 12.2656 18.2304C12.1879 17.1038 12.539 16.062 13.2499 15.298C13.9532 14.5417 14.9453 14.125 16.039 14.125C17.1327 14.125 18.1171 14.5439 18.8242 15.3046C19.5406 16.0746 19.8906 17.1142 19.8086 18.2315C19.6517 20.4299 17.9602 22.2187 16.039 22.2187ZM19.6298 23.9387C18.6678 23.4684 17.4193 23.2332 16.0395 23.2332C14.4285 23.2332 12.8638 23.6532 11.6334 24.4155C10.2383 25.2812 9.29986 26.5418 8.92088 28.0637C8.86541 28.2827 8.86017 28.5113 8.90553 28.7325C8.95089 28.9537 9.04569 29.1618 9.18283 29.3412C9.31296 29.5083 9.47966 29.6433 9.67013 29.7358C9.8606 29.8283 10.0697 29.876 10.2815 29.875H16.3518C16.4543 29.875 16.5535 29.839 16.6321 29.7734C16.7108 29.7077 16.7639 29.6165 16.7822 29.5157C16.7882 29.4812 16.7959 29.4468 16.8046 29.4129C17.2684 27.5502 18.355 25.9763 19.9606 24.829C20.0197 24.7864 20.0672 24.7298 20.0988 24.6642C20.1305 24.5987 20.1453 24.5262 20.1418 24.4535C20.1384 24.3808 20.1169 24.3101 20.0792 24.2478C20.0416 24.1855 19.989 24.1336 19.9262 24.0967C19.8403 24.0464 19.7419 23.9934 19.6298 23.9387Z"
        fill="url(#paint0_linear_6106_1097)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6106_1097"
          x1="43.5835"
          y1="8.66819"
          x2="20.5399"
          y2="50.4657"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE195" />
          <stop offset="1" stopColor="#FAAD2A" />
        </linearGradient>
      </defs>
    </svg>
  );
};
